import React from "react";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import elena from "../assets/elena.png";
import { SignedOut } from "@clerk/clerk-react";

function SideBar() {
	// Use Media Query to check for small screen sizes
	const isMobile = useMediaQuery("(max-width:600px)");

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: isMobile ? "row" : "column", // Change direction based on screen size
				justifyContent: isMobile ? "space-around" : "space-between",
				alignItems: "center",
				width: isMobile ? "100vw" : "auto",
				height: isMobile ? "auto" : "calc(100vh - 65px)",
				borderBottom: isMobile ? "1px solid #7B2855" : "none", // Bottom border for mobile
				borderRight: isMobile ? "none" : "1px solid #7B2855", // Right border for desktop
				padding: isMobile ? "10px 0" : "0", // Add padding on mobile
			}}
		>
			<Box
				sx={{
					textAlign: "center",
					paddingTop: isMobile ? 0 : 3,
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
				}}
			>
				<img
					src={elena}
					alt="Elena"
					style={{
						width: isMobile ? "100px" : "200px", // Adjust image size for both layouts
						borderRadius: "50%",
						marginBottom: "10px",
					}}
				/>
				<Typography variant={"h5"} sx={{ marginBottom: "5px" }}>
					Elena
				</Typography>
			</Box>
			<SignedOut>
				<a
					href="https://calendar.app.google/2mduEodpJ3CuAqij8"
					target="_blank"
					rel="noopener noreferrer"
					style={{ textDecoration: "none" }}
				>
					<Button
						variant="contained"
						sx={{
							background: "#7B2855",
							color: "white",
							"&:hover": {
								background: "#9B3B76",
							},
							marginBottom: "20px",
							width: "auto",
						}}
					>
						Book A Call
					</Button>
				</a>
			</SignedOut>
		</Box>
	);
}

export default SideBar;
